import HttpClient from "@/common/boot/HttpClient"

const listarCtrlEstados = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/ctrl-estados', payload);
    commit('LISTAR_DADOS', response.data.data);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

export {
  listarCtrlEstados,
}
